import React  from 'react';

import HealthIcon from "../../../../gd-components/health/health-icon/health-icon";

import Classes from "classnames";

export default function renderBooleanGroupListHeader(id, props) {
    return (
        <div className={Classes('gd-field-rag-group-list-header', props.className)}>
            <div className="group-list-header-value">
                <HealthIcon className="rag-icon" value={props.data.value}/>
            </div>
        </div>
    );
}